import { FC } from 'react';
import ReactDocumentTitle from 'react-document-title';
import { Consumer as StateConsumer } from '../context/state';

const DocumentTitle: FC = () => (
  <StateConsumer>
    {(state) => {
      let title: string | null = null;

      if (state.authentication.fetching >= 1) {
        title = 'Signing in...';
      } else if (!state.authentication.signedInUser) {
        title = 'Sign in';
      }

      if (title === null) {
        title = 'サイト改善 | Kaizen Platform';
      } else {
        title = `${title} | サイト改善 | Kaizen Platform`;
      }

      return <ReactDocumentTitle title={title} />;
    }}
  </StateConsumer>
);

export default DocumentTitle;
